import { render } from "./editTicketsManage.vue?vue&type=template&id=b9748e0c"
import script from "./editTicketsManage.vue?vue&type=script&setup=true&lang=js"
export * from "./editTicketsManage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/components/editTicketsManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b9748e0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b9748e0c', __exports__)) {
    console.log('reload')
    api.reload('b9748e0c', __exports__)
  }
  
  module.hot.accept("./editTicketsManage.vue?vue&type=template&id=b9748e0c", () => {
    console.log('re-render')
    api.rerender('b9748e0c', render)
  })

}


export default __exports__